<template>
  <v-card>

    <v-progress-circular v-if="loading"
                         indeterminate
                         color="primary">
    </v-progress-circular>

    <v-card-text>
      <part-order-properties-view v-if="partOrder != null"
                                   :partOrder="partOrder">
      <template v-slot:append>
        <entity-properties-row>
          <v-btn v-if="$featurePermissions.partOrderCRUD"
                 tile
                 color="primary"
                 @click="openEditDialog">
            {{ $t('actions.modify') }}
            <v-icon right dark>
              mdi-border-color
            </v-icon>
          </v-btn>
        </entity-properties-row>
      </template>
      </part-order-properties-view>
      <partOrder-dialog ref="partOrderDialog" @done="reload"/>
    </v-card-text>
  </v-card>
</template>

<script>
import Vue from 'vue';
import EntityPropertiesRow from '@/components/entity-crud/EntyPropertiesRow';
import PartOrdersService from '@/services/PartOrdersService';
import PartOrderDialog from '@/views/partorder/PartOrderDialog';
import PartOrderPropertiesView from '@/views/partorder/PartOrderPropertiesView';

export default Vue.extend({
  name: 'PartOrderDetails',
  components: {
    PartOrderDialog,
    PartOrderPropertiesView,
    EntityPropertiesRow,
  },
  data() {
    return {
      partOrder: null,
      loading: false,
    };
  },
  mounted() {
    this.reload();
  },
  methods: {
    reload() {
      this.loading = true;
      PartOrdersService.get(this.partOrderId).then(result => {
        this.partOrder = result.data.partOrder;
      }).catch(err => {
        console.log(JSON.stringify(err));
      }).finally(() => {
        this.loading = false;
      });
    },

    openEditDialog() {
      this.$refs.partOrderDialog.openEditForPartOrder(this.partOrderId);
    },
  },

  computed: {
    partOrderId() {
      return parseInt(this.$route.params.id, 10);
    },
  },
});
</script>
